"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = FileCard;
var _preact = require("preact");
var _hooks = require("preact/hooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _nonSecure = require("nanoid/non-secure");
var _getFileTypeIcon = _interopRequireDefault(require("../../utils/getFileTypeIcon.js"));
var _ignoreEvent = _interopRequireDefault(require("../../utils/ignoreEvent.js"));
var _FilePreview = _interopRequireDefault(require("../FilePreview.js"));
var _RenderMetaFields = _interopRequireDefault(require("./RenderMetaFields.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function FileCard(props) {
  var _getMetaFields;
  var files = props.files,
    fileCardFor = props.fileCardFor,
    toggleFileCard = props.toggleFileCard,
    saveFileCard = props.saveFileCard,
    metaFields = props.metaFields,
    requiredMetaFields = props.requiredMetaFields,
    openFileEditor = props.openFileEditor,
    i18n = props.i18n,
    i18nArray = props.i18nArray,
    className = props.className,
    canEditFile = props.canEditFile;
  var getMetaFields = function getMetaFields() {
    return typeof metaFields === 'function' ? metaFields(files[fileCardFor]) : metaFields;
  };
  var file = files[fileCardFor];
  var computedMetaFields = (_getMetaFields = getMetaFields()) != null ? _getMetaFields : [];
  var showEditButton = canEditFile(file);
  var storedMetaData = {};
  computedMetaFields.forEach(function (field) {
    var _file$meta$field$id;
    storedMetaData[field.id] = (_file$meta$field$id = file.meta[field.id]) != null ? _file$meta$field$id : '';
  });
  var _useState = (0, _hooks.useState)(storedMetaData),
    _useState2 = _slicedToArray(_useState, 2),
    formState = _useState2[0],
    setFormState = _useState2[1];
  var handleSave = (0, _hooks.useCallback)(function (ev) {
    ev.preventDefault();
    saveFileCard(formState, fileCardFor);
  }, [saveFileCard, formState, fileCardFor]);
  var updateMeta = function updateMeta(newVal, name) {
    setFormState(_objectSpread(_objectSpread({}, formState), {}, _defineProperty({}, name, newVal)));
  };
  var handleCancel = function handleCancel() {
    toggleFileCard(false);
  };
  var _useState3 = (0, _hooks.useState)(function () {
      var formEl = document.createElement('form');
      formEl.setAttribute('tabindex', '-1');
      formEl.id = (0, _nonSecure.nanoid)();
      return formEl;
    }),
    _useState4 = _slicedToArray(_useState3, 1),
    form = _useState4[0];
  (0, _hooks.useEffect)(function () {
    document.body.appendChild(form);
    form.addEventListener('submit', handleSave);
    return function () {
      form.removeEventListener('submit', handleSave);
      document.body.removeChild(form);
    };
  }, [form, handleSave]);
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('uppy-Dashboard-FileCard', className),
    "data-uppy-panelType": "FileCard",
    onDragOver: _ignoreEvent.default,
    onDragLeave: _ignoreEvent.default,
    onDrop: _ignoreEvent.default,
    onPaste: _ignoreEvent.default
  }, (0, _preact.h)("div", {
    className: "uppy-DashboardContent-bar"
  }, (0, _preact.h)("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, i18nArray('editing', {
    file: (0, _preact.h)("span", {
      className: "uppy-DashboardContent-titleFile"
    }, file.meta ? file.meta.name : file.name)
  })), (0, _preact.h)("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    form: form.id,
    title: i18n('finishEditingFile'),
    onClick: handleCancel
  }, i18n('cancel'))), (0, _preact.h)("div", {
    className: "uppy-Dashboard-FileCard-inner"
  }, (0, _preact.h)("div", {
    className: "uppy-Dashboard-FileCard-preview",
    style: {
      backgroundColor: (0, _getFileTypeIcon.default)(file.type).color
    }
  }, (0, _preact.h)(_FilePreview.default, {
    file: file
  }), showEditButton && (0, _preact.h)("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-Dashboard-FileCard-edit",
    onClick: function onClick(event) {
      // When opening the image editor we want to save any meta fields changes.
      // Otherwise it's confusing for the user to click save in the editor,
      // but the changes here are discarded. This bypasses validation,
      // but we are okay with that.
      handleSave(event);
      openFileEditor(file);
    }
  }, i18n('editImage'))), (0, _preact.h)("div", {
    className: "uppy-Dashboard-FileCard-info"
  }, (0, _preact.h)(_RenderMetaFields.default, {
    computedMetaFields: computedMetaFields,
    requiredMetaFields: requiredMetaFields,
    updateMeta: updateMeta,
    form: form,
    formState: formState
  })), (0, _preact.h)("div", {
    className: "uppy-Dashboard-FileCard-actions"
  }, (0, _preact.h)("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Dashboard-FileCard-actionsBtn"
    // If `form` attribute is supported, we want a submit button to trigger the form validation.
    // Otherwise, fallback to a classic button with a onClick event handler.
    ,

    type: "submit",
    form: form.id
  }, i18n('saveChanges')), (0, _preact.h)("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-link uppy-Dashboard-FileCard-actionsBtn",
    type: "button",
    onClick: handleCancel,
    form: form.id
  }, i18n('cancel')))));
}